import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { GridProps, Typography } from '@mui/material';
import HomeGridCard from './HomeGridCard';

const t = (key: string, options?) => translate('home', key, options);

type Props = {
  paperClass: string;
} & GridProps;

const cards = [
  {
    title: 'resources',
    text: 'resourcesSubtitle',
    link: '/resources',
  },
  {
    title: 'helpAndSupport',
    text: 'helpAndSupportSubtitle',
    link: '/help-and-support',
    sendTelemetryEvent: true,
  },
  {
    title: 'professionalLearning',
    text: 'professionalLearningDescription',
    link: '/professional-learning',
    sendTelemetryEvent: true,
  },
  {
    title: 'preferencesAndClassSettings',
    text: 'yourProfileAndOtherSettings',
    link: '/preferences',
    sendTelemetryEvent: true,
  },
];

const HomeQuadrantLinkRow: React.FC<Props> = ({ paperClass, classes }) => {
  return (
    <>
      {cards.map((card) => (
        <HomeGridCard
          key={card.title}
          xs={3}
          paperProps={{ className: paperClass }}
          classes={classes}
          boxProps={{ margin: '24px', minHeight: 176 }}
          link={card.link}
          title={card.title}
          sendEvent={card.sendTelemetryEvent}
        >
          <Typography
            variant="h2"
            style={{ fontWeight: 'bold', lineHeight: 'normal', color: 'black' }}
            gutterBottom
          >
            {t(card.title)}
          </Typography>
          <Typography variant="subtitle1">{t(card.text)}</Typography>
        </HomeGridCard>
      ))}
    </>
  );
};

export default HomeQuadrantLinkRow;
